module.exports = __webpack_public_path__ + "static/img/our-customers-Industry-row2.0dd82f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/our-customers-Industry-row2.jpg
// module id = MtIw
// module chunks = 0